<template>
  <div>
    <el-tabs v-model="$store.state.iframeTabsActive" type="card" :closable="$store.state.iframeTabs.length>1" @tab-remove="removeTab">
      <el-tab-pane
          v-for="(item, index) in $store.state.iframeTabs"
          :key="item.name"
          :label="item.title"
          :name="item.name"
      size="small">
        <iframe class="childTabView"
                :id="'iframe'+item.name" :src="item.url" frameborder="0"  scrolling="auto">
        </iframe>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "TagsView",
  data() {
    return {

    }
  },
  methods:{
    removeTab(targetName){
      let tabs = this.$store.state.iframeTabs;
      let activeName = this.$store.state.iframeTabsActive;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }

      this.$store.state.iframeTabsActive = activeName;
      this.$store.state.iframeTabs = tabs.filter(tab => tab.name !== targetName);

    }
  }
}
</script>

<style scoped>
.el-tab-pane{
  margin-left: 5px;
}

.childTabView{
  width: 100%;
  height: calc(100vh - 122px);
}
</style>